import React from "react";
import AppRoutes from "./AppRoutes";

const App = () => {
  return (
    <div className="container">
      <AppRoutes />
    </div>
  );
};

export default App;
